import { createStore, withProps } from '@ngneat/elf';
import { CompanyContact, Contact, CompanyContactExtras, ContactDto } from '@/types';

export interface ContactStateProps {
  response?: Contact;
  companyResponse?: Partial<CompanyContact>;
  dto?: Partial<ContactDto>;
  companyContactExtraDto?: CompanyContactExtras;
}

const contactObjectInitialState: Contact = { id: 0, nom: '', address: '', tel1: '', tel2: '', email: '' };

export const contactInitialState: ContactStateProps = {
  response: { ...contactObjectInitialState },
  companyResponse: {
    contact: { ...contactObjectInitialState },
    societeContact: { principal: false, representantLegal: false },
  },
  dto: {
    nom: '',
    address: '',
    tel1: '',
    tel2: '',
    email: '',
  },
  companyContactExtraDto: { principal: false, representantLegal: false },
};

export const contactStateStore = createStore({ name: 'contact-state' }, withProps<ContactStateProps>({ ...contactInitialState }));
